export default "__VITE_ASSET__4TvX9A28__"